import React from 'react';
import { observer } from 'mobx-react';

// Components
import Loader from './Common/Loader';
import Dialog from './Common/Dialog';

// Store
import store from '../stores/';

class AppLoggedOut extends React.Component {
  render() {
    // Import styles
    if(!document.querySelector('link[href*="screen.css"]')) {
      const { highContrast } = store.SessionStore;

      let defaultStyles = document.createElement('link');
      defaultStyles.rel = `${highContrast ? 'alternate stylesheet' : 'stylesheet '}`;
      defaultStyles.type = 'text/css';
      defaultStyles.href = './static/css/screen.css';

      let highContrastStyles = document.createElement('link');
      highContrastStyles.rel = `${highContrast ? 'stylesheet' : 'alternate stylesheet'}`;
      highContrastStyles.type = 'text/css';
      highContrastStyles.href = './static/css/hi-c.css';

      document.head.appendChild(defaultStyles);
      document.head.appendChild(highContrastStyles);
    }

    // Detect touch device
    const docRoot = document.querySelector('html');
    if ('ontouchstart' in document.documentElement) {
      docRoot.classList.add('touch');
    }

    document.querySelector('body').classList.add('logged-out')

    return (
      <div className="viewport">
        {React.cloneElement(this.props.children, this.props)}

        {store.SessionStore.loading &&
          <Loader store={store} />
        }

        {store.SessionStore.dialog &&
          <Dialog store={store} />
        }
      </div>
    )
  }
}

export default observer(AppLoggedOut);


// WEBPACK FOOTER //
// ./src/app/components/AppLoggedOut.js